module.exports = __webpack_public_path__ + "img/eva-er-ikke-laengere-2.5ab08706.png";